<script lang="jsx">
export default {
  data(){
    return {
      formData:{
        supplierName:'',
        confirmationState: ''
      }
    }
  },
  methods:{
    handleQuery(){
      this.$emit('query', this.formData)
    },
    // 重置
    handleReset() {
      this.$refs.form.resetFields()
      this.handleQuery()
    }
  },
  render(){
    return (
    <fin-form label-position={this.config.searchLabelPosition} inline={this.config.searchInline} class="mt-24" {...{props:{model: this.formData}}} ref="form" label-width="120px">
      <fin-form-item label="供应商企业名称" prop="supplierName">
        <fin-input clearable class="w-256" value={this.formData.supplierName} on-input={v=>this.formData.supplierName=v} placeholder={'供应商企业名称'}></fin-input>
      </fin-form-item>
      <fin-form-item label="确权状态" prop="confirmationState">
        <fin-select clearable class="w-256" value={this.formData.confirmationState} on-input={v=>this.formData.confirmationState=v} placeholder={'确权状态'}>
          <fin-option value="WAITING" label="待确权"></fin-option>
          <fin-option value="FINISH" label="已确权"></fin-option>
          <fin-option value="REJECT" label="拒绝确权"></fin-option>
        </fin-select>
      </fin-form-item>
      <fin-form-item class="align-bottom">
        <fin-button type="primary" on-click={this.handleQuery.bind(this)}>查询</fin-button>
        <fin-button plain class="ml-10" on-click={this.handleReset.bind(this)}>重置</fin-button>
      </fin-form-item>
    </fin-form>)
  }
};
</script>
